export const STORAGE_KEYS = {
  TOKEN: 'TOKEN',
  NAME: 'NAME',
  DATE: 'DATE',
  USER_REFRESH_COOKIE: 'REFRESH_TOKEN',
  USER_COOKIE: 'USER_TOKEN',
  SELECTED_ORG_ID: 'SELECTED_ORG_ID',
  ORG_ACCESS_TOKEN: 'ACCESS_TOKEN',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
